import Model from 'flarum/common/Model';
export default class Impersonate extends Model {
  reason() {
    return Model.attribute('reason').call(this);
  }
}
flarum.reg.add('fof-impersonate', 'common/models/Impersonate', Impersonate);